module.exports = __webpack_public_path__ + "static/media/spots.07feb461.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/partner-reports/spots.svg
// module id = 1119
// module chunks = 1